import { usePageNumberFromUrl, usePerPageValueFromUrl, useSortValueFromUrl } from 'idsk-react-components';
import { SortDirectionEnum } from 'tezaury-frontend-ts-axios';
import PublikovanyTerminFilter from '../../../model/PublikovanyTerminFilter';
import { fetchPublikovanyTerminPage } from '../../../client/termin/publikovanyTerminListClient';
import PublikovanyTerminListPage from '../../../model/PublikovanyTerminListPage';
import { ClientStatus } from '../../../model/ClientStatus';
import { defaultPerPageValue, perPageDataArray } from '../../../constants/PaginationPerPageConstants';
import { useClientFetch } from '../../../context/ClientStatusContext';

interface ReturnType {
  publikovanyTerminPage: PublikovanyTerminListPage;
  requestStatus: ClientStatus;
}

const getSortBy = (sortDirection): SortDirectionEnum => (sortDirection === 'desc'
  ? SortDirectionEnum.Desc : SortDirectionEnum.Asc);

export default (filter: PublikovanyTerminFilter): ReturnType => {
  const { page } = usePageNumberFromUrl('page');
  const { perPageValue } = usePerPageValueFromUrl('perPage', perPageDataArray, defaultPerPageValue);
  const { sort } = useSortValueFromUrl();
  const {
    data: publikovanyTerminPage,
    status: requestStatus,
  } = useClientFetch(
    fetchPublikovanyTerminPage,
    [filter, page, perPageValue, sort[0] ? sort[0] : 'terminSort', getSortBy(sort[1])],
    [JSON.stringify(filter), page, perPageValue, sort[0], sort[1]],
  );

  return {
    publikovanyTerminPage,
    requestStatus,
  };
};
